module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Pagination":{"ariaLabel":"Stránkování","buttonLoadMore":{"ariaLabel":"Zobrazit další produkty","text":"Zobrazit další"},"next":"Další","previous":"Zpět"}}}')
  delete Component.options._Ctor
}
